function printSection(targetSelector) {
    const targetElement = document.querySelector(targetSelector);

    if (!targetElement) {
        console.error('Print target not found:', targetSelector);
        return;
    }

    // collect stylesheets
    const stylesheets = [...document.querySelectorAll('link[rel="stylesheet"]')]
        .map((link) => link.outerHTML)
        .join('');

    // print styles
    const printStyles = `
      <style>
        html,
        body {
          margin: 0;
          padding: 0;
          background: #fff;
        }

        body {
          padding: 30px;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        img,
        svg,
        video {
          max-width: 100%;
        }

        .print-wrapper.hidden {
          display: block !important;}

        * {
          box-sizing: border-box;
        }

        @page {
          size: auto;
          margin: 12mm;
        }
      </style>
    `;

    // create hidden iframe
    const iframe = document.createElement('iframe');

    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    document.body.appendChild(iframe);

    const iframeDoc =
        iframe.contentWindow || iframe.contentDocument;

    const doc =
        iframe.contentDocument || iframe.contentWindow.document;

    doc.open();

    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${document.title}</title>

          ${stylesheets}

          ${printStyles}
        </head>

        <body>
          ${targetElement.outerHTML}
        </body>
      </html>
    `);

    doc.close();

    const waitForAssets = () => {
        const images = doc.images;

        const imagePromises = [...images].map((img) => {
            if (img.complete) return Promise.resolve();

            return new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = resolve;
            });
        });

        return Promise.all(imagePromises);
    };

    waitForAssets().then(() => {
        setTimeout(() => {
            iframe.contentWindow.focus();

            iframe.contentWindow.print();

            iframe.contentWindow.onafterprint = () => {
                document.body.removeChild(iframe);
            };
        }, 300);
    });
}